import { ConversationMessageDto } from '@endion/types';

export function MessageBubble({ children, role }: { children: React.ReactNode; role: ConversationMessageDto['role'] }) {
  return (
    <div
      className={`${
        role === 'assistant' ? 'bg-messageBubbleColor' : 'bg-primary text-white'
      } p-3 rounded-lg break-words font-medium text-sm space-y-2 max-w-64 w-fit`}
    >
      {children}
    </div>
  );
}
